import { ChangeEvent, FC } from 'react';
import { useExclusions } from '../../exclusions/actions/exclusions-actions';
import ApplicationIrrelevantModal from './ApplicationIrrelevantModal';

const ApplicationIrrelevant: FC<
  React.PropsWithChildren<ApplicationIrrelevantProps>
> = ({
  appName,
  appId,
  applicationIrrelevantModal,
  onIrrelevantApp,
  handleClose,
  excludeComment,
  setExcludeComment,
}) => {
  const { isIrrelevantApplicationLoading } = useExclusions();

  return (
    <ApplicationIrrelevantModal
      open={applicationIrrelevantModal}
      onCloseApplicationIrrelevant={handleClose}
      handleApplicationIrrelevant={onIrrelevantApp}
      isLoading={isIrrelevantApplicationLoading}
      appName={appName}
      appId={appId}
      excludeComment={excludeComment}
      setExcludeComment={setExcludeComment}
    />
  );
};

export interface ApplicationIrrelevantProps {
  appName?: string;
  appId?: string;
  applicationIrrelevantModal: boolean;
  onIrrelevantApp: () => void;
  handleClose: () => void;
  excludeComment?: string;
  setExcludeComment: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

export default ApplicationIrrelevant;
